import React from 'react'
import { connect } from "react-redux";
import { SetMethodsActive, GetMethods, RemoveMethodsActive } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { RemoveAll } from '$Deposits/store/actions/DepositUpdate'


class Components extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bannerShow: true,
        };
    }

    componentDidMount() {
        this.props.RemoveMethodsActive()
        const { ActiveMethods } = GetParamsData()
        this.props.GetMethods && this.props.GetMethods(ActiveMethods)
    }
    componentWillUnmount() {
        RemoveAll && RemoveAll()
    }

    render() {
        const {
            bannerShow,
        } = this.state

        const {
            Banner,
            Methods,
            MethodsView,
            MethodsCode,
            SetMethodsActive,
            MethodsActive,
        } = this.props
        const { paymentMethods = [] } = Methods || {}
        const { code } = MethodsActive || {}


        return (
            <>
                <Banner
                    bannerShow={bannerShow}
                    onClose={() => { this.setState({ bannerShow: false }) }}
                />
                <MethodsView
                    activeCode={code}
                    paymentMethods={paymentMethods}
                    onChange={(val) => { 
                        if(code!==val){
                            SetMethodsActive(val) 
                        }
                    }}
                />
                <MethodsCode
                    activeCode={code}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    Methods: state.Methods,
    MethodsActive: state.MethodsActive,
});
const mapDispatchToProps = {
    SetMethodsActive: (data = {}) => SetMethodsActive(data),
    GetMethods: (data = '') => GetMethods(data),
    RemoveMethodsActive: () => RemoveMethodsActive()
};
export default connect(mapStateToProps, mapDispatchToProps)(Components);


